import { action, observable } from "mobx";
import TourJobType from "~/constants/TourJob/TourJobType";
import TourJobStatus from "~/constants/TourJob/TourJobStatus";
import Provider from "../Provider";
import TourJobFile from "./TourJobFile";

class TourJob {
  /**
   * @property {number|null}
   */
  @observable tourJobId = null;

  /**
   * @property {number|null}
   */
  @observable providerId = null;

  /**
   * @property {number|null}
   */
  @observable tourId = null;

  /**
   * @property {number}
   */
  @observable typeId = TourJobType.IMMERSIVE_3D_TOUR_PANORAMAS;

  /**
   * @property {number}
   */
  @observable itemCount = 0;

  /**
   * @property {number|null}
   */
  @observable estimatedTime = null;

  /**
   * @property {number}
   */
  @observable creationDts = null;

  /**
   * @property {number}
   */
  @observable startedDts = null;

  /**
   * @property {number}
   */
  @observable finishedDts = null;

  /**
   * @property {Array}
   */
  @observable refunds = [];

  /**
   * @property {Provider|null}
   */
  @observable provider = null;

  /**
   * @property {array}
   */
  @observable tourJobFiles = [];

  constructor({
    tourJobId = null,
    providerId = null,
    tourId = null,
    typeId = null,
    status = null,
    itemCount = null,
    estimatedTime = null,
    creationDts = null,
    startedDts = null,
    finishedDts = null,
    refunds = [],
    provider = null,
    tourJobFiles = [],
  }) {
    this.tourJobId = tourJobId;
    this.providerId = providerId;
    this.tourId = tourId;
    this.typeId = typeId;
    this.status = status;
    this.itemCount = itemCount;
    this.estimatedTime = estimatedTime;
    // We need to normalize timestamps since PHP doesn't account for milliseconds but javascript does
    this.creationDts = creationDts ? creationDts * 1000 : null;
    this.startedDts = startedDts ? startedDts * 1000 : null;
    this.finishedDts = finishedDts ? finishedDts * 1000 : null;

    this.setRefunds(refunds);

    this.provider = new Provider(provider);

    tourJobFiles.forEach(tourJobFile => this.tourJobFiles.push(new TourJobFile(tourJobFile)));
  }

  /**
   * Get a list of status options consumable by a Dropdown component.
   */
  static getStatusOptions() {
    return [
      { key: "any", value: "", text: "Any" },
      { key: TourJobStatus.IN_CREATION, value: TourJobStatus.IN_CREATION, text: "In Creation" },
      { key: TourJobStatus.IN_PROGRESS, value: TourJobStatus.IN_PROGRESS, text: "In Progress" },
      { key: TourJobStatus.DONE, value: TourJobStatus.DONE, text: "Done" },
    ];
  }

  /**
   * Set refunds
   *
   * @param {Array|null} refunds
   */
  @action
  setRefunds(refunds = []) {
    this.refunds = [];

    if (refunds !== null) {
      refunds.forEach(refund => this.refunds.push(refund));
    }
  }
}

export default TourJob;
